import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDebtSelectorStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    width: '100%',
    boxSizing: 'border-box',
  },

  sectionTitle: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase200,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },

  // ── Tarjeta de flujo Deudor → Acreedor ──
  flowCard: {
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalXL),
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow4,
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalL,
  },
  flowParty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: tokens.spacingVerticalXS,
    minWidth: 0,
    textAlign: 'center',
  },
  flowPartyBadge: {
    width: '44px',
    height: '44px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.borderRadius(tokens.borderRadiusCircular),
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
  },
  flowPartyBadgeCreditor: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
  },
  flowPartyRole: {
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase100,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    display: 'block',
  },
  flowPartyName: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase400,
    maxWidth: '100%',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // Conector central con flecha en pill
  flowConnector: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: tokens.spacingVerticalXS,
  },
  flowConnectorPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    ...shorthands.borderRadius(tokens.borderRadiusCircular),
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    boxShadow: tokens.shadow2,
  },
  flowConnectorLabel: {
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    lineHeight: tokens.lineHeightBase100,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },

  // ── Barra de herramientas: auto-imputación + disponible ──
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalS,
    flexWrap: 'wrap',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    backgroundColor: tokens.colorNeutralBackground3,
  },
  availableWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    rowGap: tokens.spacingVerticalXXS,
  },
  availableLabel: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase100,
  },
  availableValue: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase300,
  },
  availableValueZero: {
    color: tokens.colorStatusSuccessForeground1,
  },
  availableValueNegative: {
    color: tokens.colorStatusDangerForeground1,
  },

  // ── Contenedor de la grilla ──
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.overflow('hidden'),
  },

  // ── Celda de "Monto a aplicar": input + acciones ──
  amountCell: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXS,
    minWidth: 0,
    width: '100%',
    // El Input de Fluent trae min-width propio que desborda la columna; lo forzamos a encoger.
    '& .fui-Field': {
      flexGrow: 1,
      flexShrink: 1,
      minWidth: 0,
    },
    '& .fui-Input': {
      minWidth: 0,
      width: '100%',
    },
  },

  // ── Celda genérica con un único input (ej. tipo de cambio) ──
  cellField: {
    width: '100%',
    minWidth: 0,
    '& .fui-Input': {
      minWidth: 0,
      width: '100%',
    },
  },
});
